
// region JS Imports

// region External Modules
import u from "umbrellajs"
// endregion External Modules

// Private Modules
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import {
  Factory,
} from "./factory"
// endregion Private Components

// endregion JS Imports


const CELL_CLASS_NAME = "cell--app--current-area-size-unit--selection-menu--button-style"

const initAllMatchingElements = () => {
  u(`.${CELL_CLASS_NAME}`).each((el) => {
    Factory.create({
      cell: el,
    })
  })
}

function onLoad() {
  initAllMatchingElements()
}

export default {
  initAllMatchingElements,
}

export {
  onLoad,
}
